import { i18n } from '@/plugins/i18n';
import { ROLES, type Role } from '@teamworksdev/influencer/core';

export const adminRoles: Readonly<Role[]> = [
	ROLES.SUPER_ADMINISTRATOR,
	ROLES.ADMINISTRATOR,
	ROLES.CLIENT_SUCCESS,
] as const;

export function isAdminRole(role: Role) {
	return adminRoles.includes(role);
}

export function getRoleName(role: Role): string {
	const roleMap = new Map<Role, string>([
		[1, i18n.global.t('userProfileRoles.superAdmin')],
		[2, i18n.global.t('userProfileRoles.admin')],
		[3, i18n.global.t('userProfileRoles.clientSuccess')],
		[4, i18n.global.t('userProfileRoles.teamUser')],
		[5, i18n.global.t('userProfileRoles.complianceOfficer')],
		[6, i18n.global.t('userProfileRoles.agent')],
		[7, i18n.global.t('userProfileRoles.brandUser')],
	]);
	const roleName = roleMap.get(role);
	if (!roleName) {
		console.warn('unknown role');
		return i18n.global.t('unknown');
	}
	return roleName;
}
